import { DeclaredUnit } from '../interfaces/IComponentDetails';

// Declared units the user provides the product mass for. For every other declared unit the mass is
// derived (see resolveProductMassPerDeclaredUnit) and the input is hidden.
export const PRODUCT_MASS_APPLICABLE_DECLARED_UNITS = [
  DeclaredUnit.liter,
  DeclaredUnit.cubicMeter,
  DeclaredUnit.squareMeter,
  DeclaredUnit.piece,
];

export const PRODUCT_MASS_SUFFIX = 'kg';

export const isProductMassApplicable = (declaredUnit?: DeclaredUnit): boolean => {
  return !!declaredUnit && PRODUCT_MASS_APPLICABLE_DECLARED_UNITS.includes(declaredUnit);
};

// Mirrors the API's resolveProductMassPerDeclaredUnit: a kilogram based PCF weighs its declared
// amount, and units without a mass weigh 0.
export const resolveProductMassPerDeclaredUnit = (
  declaredUnit?: DeclaredUnit,
  unitaryProductAmount?: number | null,
  providedMass?: number | null,
): number | null => {
  if (!declaredUnit) {
    return null;
  }

  if (declaredUnit === DeclaredUnit.kilogram) {
    return unitaryProductAmount ?? null;
  }

  if (!isProductMassApplicable(declaredUnit)) {
    return 0;
  }

  return providedMass ?? null;
};
